import Api from "../../../api/api";
import {Listeners} from "../../../constants/listeners";

/**
 * Селектор «Текущее состояние / месяц помесячного архива рекламы» на страницах объявлений и запросов.
 * month = '' — текущее состояние, иначе 'YYYY-MM' из списка месяцев. Месяц живёт в ?month=;
 * смена месяца — переход без hash: фильтр, сортировка и страница таблицы (они в hash) сбрасываются.
 * Месяц не из списка — текущее состояние, ?month= убирается. Архив есть только у яндексовых баз:
 * у остальных месяцы не грузятся.
 * Компонент задаёт db и domain (props) и apiPath — URL текущего состояния; архив — apiPath + '/archive'.
 * Другой список месяцев — monthsPath и monthsParams; withCurrentState: false — у отчёта только архив:
 * месяц по умолчанию — последний из списка.
 * Сам селектор «Период» стоит в шапке страницы, вне слота таблицы, поэтому связь с ним — через
 * $emitter: ADS_MONTHS_STATE туда, ADS_MONTH_CHANGE обратно.
 */
export default {
    data() {
        const requested = this.requestedMonth();

        return {
            months: [],
            monthsLoaded: false,
            month: requested,
            // с ?month= таблицу показываем, только когда месяц сверен со списком
            ready: requested === '',
            monthsPath: '/report/simple/context/ads/archive/months',
            withCurrentState: true,
        }
    },
    async created() {
        this.$emitter.on(Listeners.ADS_MONTH_CHANGE, this.onChangeMonth);

        if (window.report_db?.engine === 'yandex') {
            try {
                this.months = await new Api().get(this.monthsPath, this.monthsParams);
            } catch (e) {
                this.months = [];
            }
        }
        this.monthsLoaded = true;

        if (!this.isKnownMonth(this.month)) {
            this.month = this.defaultMonth();
            this.replaceUrlMonth(this.month);
        }
        this.ready = true;
        this.emitMonthsState();
    },
    beforeUnmount() {
        this.$emitter.off(Listeners.ADS_MONTH_CHANGE, this.onChangeMonth);
    },
    watch: {
        month() {
            if (this.monthsLoaded) {
                this.emitMonthsState();
            }
        },
    },
    computed: {
        monthsParams() {
            return {base: this.db, domain: this.domain};
        },
        apiUrl() {
            const params = `base=${this.db}&domain=${this.domain}`;

            return this.month
                ? `${this.apiPath}/archive?${params}&month=${this.month}`
                : `${this.apiPath}?${params}`;
        },
    },
    methods: {
        emitMonthsState() {
            this.$emitter.emit(Listeners.ADS_MONTHS_STATE, {
                months: this.months,
                month: this.month,
                withCurrentState: this.withCurrentState,
            });
        },
        onChangeMonth(month) {
            const url = new URL(this.urlWithMonth(month));
            url.hash = '';
            window.location.assign(url.toString());
        },
        requestedMonth() {
            return new URLSearchParams(window.location.search).get('month') || '';
        },
        isKnownMonth(month) {
            return (month === '' && this.withCurrentState) || this.months.some(m => m.month === month);
        },
        defaultMonth() {
            return this.withCurrentState ? '' : (this.months[0]?.month || '');
        },
        replaceUrlMonth(month) {
            history.replaceState({}, '', this.urlWithMonth(month));
        },
        urlWithMonth(month) {
            const url = new URL(window.location.href);
            if (month) {
                url.searchParams.set('month', month);
            } else {
                url.searchParams.delete('month');
            }

            return url.toString();
        },
    },
}
